import AddUserModalError from './component'

export default AddUserModalError



// WEBPACK FOOTER //
// ./src/components/AddUserModalError/index.js